import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { configure, start, stop } from "../../services/hubs/EnrollmentHub";
import useAppConfig from "../shared/useAppConfig";
import { useAppMode, AppModes } from "../../services/appModeService";

const useSignalRHub = () => {
  const config = useAppConfig();
  const { appMode } = useAppMode();
  const { accounts } = useMsal();
  const isAuthenticated = accounts.length > 0;

  useEffect(() => {
    if (appMode === AppModes.NotSet || !isAuthenticated) {
      return;
    }

    const startHub = async () => {
      console.log(`[useSignalRHub] Starting enrollment hub for ${AppModes[appMode]} mode`);
      await configure(config.apiUrl.toString());
      await start();
    };

    void startHub();

    return () => {
      stop();
    };
  }, [config.apiUrl, appMode, isAuthenticated]);
};

export default useSignalRHub;
